import GreenTick from "../../images/icons/tick.png";

export default function GreenTickIcon() {
  return <img src={GreenTick} alt="Green Tick" />;
}
